import { defineComponent as yo, h as f, watchEffect as po, ref as j, inject as xo, computed as $ } from "vue";
import { useRtl as vo } from "./highrise1067.mjs";
import { createHoverColor as x, createPressedColor as z } from "./highrise1068.mjs";
import { isSafari as go } from "./highrise1069.mjs";
import { buttonGroupInjectionKey as Co } from "./highrise1070.mjs";
import Bo from "./highrise1071.mjs";
import { resolveWrappedSlot as Q, isSlotEmpty as So } from "./highrise1059.mjs";
import Po from "./highrise1072.mjs";
import To from "./highrise1073.mjs";
import $o from "./highrise1074.mjs";
import zo from "./highrise1075.mjs";
import { warnOnce as wo } from "./highrise1064.mjs";
import Ro from "./highrise628.mjs";
import Ho from "./highrise1056.mjs";
import ko from "./highrise1053.mjs";
import L from "./highrise984.mjs";
import Eo from "./highrise1000.mjs";
import { createKey as t } from "./highrise314.mjs";
import { changeColor as w } from "./highrise993.mjs";
import { useThemeClass as Oo } from "./highrise1062.mjs";
import { color2Class as W } from "./highrise1076.mjs";
import { call as Do } from "./highrise1077.mjs";
const Fo = Object.assign(Object.assign({}, L.props), {
  color: String,
  textColor: String,
  text: Boolean,
  block: Boolean,
  loading: Boolean,
  disabled: Boolean,
  circle: Boolean,
  size: String,
  ghost: Boolean,
  round: Boolean,
  secondary: Boolean,
  tertiary: Boolean,
  quaternary: Boolean,
  strong: Boolean,
  focusable: {
    type: Boolean,
    default: !0
  },
  keyboard: {
    type: Boolean,
    default: !0
  },
  tag: {
    type: String,
    default: "button"
  },
  type: {
    type: String,
    default: "default"
  },
  dashed: Boolean,
  renderIcon: Function,
  iconPlacement: {
    type: String,
    default: "left"
  },
  attrType: {
    type: String,
    default: "button"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  onClick: [Function, Array],
  nativeFocusBehavior: {
    type: Boolean,
    default: !go
  }
}), Io = yo({
  name: "Button",
  props: Fo,
  slots: Object,
  setup(e) {
    process.env.NODE_ENV !== "production" && po(() => {
      const {
        dashed: r,
        ghost: a,
        text: d,
        secondary: o,
        tertiary: B,
        quaternary: C
      } = e;
      (r || a || d) && (o || B || C) && wo("button", "`dashed`, `ghost` and `text` props can't be used along with `secondary`, `tertiary` and `quaternary` props.");
    });
    const S = j(null), v = j(null), b = j(!1), m = Ro(() => !e.quaternary && !e.tertiary && !e.secondary && !e.text && (!e.color || e.ghost || e.dashed) && e.bordered), A = xo(Co, {}), {
      mergedSizeRef: R
    } = Ho({}, {
      defaultSize: "medium",
      mergedSize: (r) => {
        const {
          size: a
        } = e;
        if (a) return a;
        const {
          size: d
        } = A;
        if (d) return d;
        const {
          mergedSize: o
        } = r || {};
        return o ? o.value : "medium";
      }
    }), H = $(() => e.focusable && !e.disabled), X = (r) => {
      var a;
      H.value || r.preventDefault(), !e.nativeFocusBehavior && (r.preventDefault(), !e.disabled && H.value && ((a = S.value) === null || a === void 0 || a.focus({
        preventScroll: !0
      })));
    }, J = (r) => {
      var a;
      if (!e.disabled && !e.loading) {
        const {
          onClick: d
        } = e;
        d && Do(d, r), e.text || (a = v.value) === null || a === void 0 || a.play();
      }
    }, U = (r) => {
      switch (r.key) {
        case "Enter":
          if (!e.keyboard)
            return;
          b.value = !1;
      }
    }, Y = (r) => {
      switch (r.key) {
        case "Enter":
          if (!e.keyboard || e.loading) {
            r.preventDefault();
            return;
          }
          b.value = !0;
      }
    }, Z = () => {
      b.value = !1;
    }, {
      inlineThemeDisabled: G,
      mergedClsPrefixRef: k,
      mergedRtlRef: oo
    } = ko(e), eo = L("Button", "-button", Bo, Eo, e, k), ro = vo("Button", oo, k), K = $(() => {
      const r = eo.value, {
        common: {
          cubicBezierEaseInOut: a,
          cubicBezierEaseOut: d
        },
        self: o
      } = r, {
        rippleDuration: B,
        opacityDisabled: C,
        fontWeight: E,
        fontWeightStrong: O
      } = o, u = R.value, {
        dashed: D,
        type: y,
        ghost: F,
        text: h,
        color: l,
        round: V,
        circle: I,
        textColor: p,
        secondary: to,
        tertiary: q,
        quaternary: no,
        strong: lo
      } = e, io = {
        "--n-font-weight": lo ? O : E
      };
      let i = {
        "--n-color": "initial",
        "--n-color-hover": "initial",
        "--n-color-pressed": "initial",
        "--n-color-focus": "initial",
        "--n-color-disabled": "initial",
        "--n-ripple-color": "initial",
        "--n-text-color": "initial",
        "--n-text-color-hover": "initial",
        "--n-text-color-pressed": "initial",
        "--n-text-color-focus": "initial",
        "--n-text-color-disabled": "initial"
      };
      const P = y === "tertiary", M = y === "default", n = P ? "default" : y;
      if (h) {
        const s = p || l;
        i = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": "#0000",
          "--n-text-color": s || o[t("textColorText", n)],
          "--n-text-color-hover": s ? x(s) : o[t("textColorTextHover", n)],
          "--n-text-color-pressed": s ? z(s) : o[t("textColorTextPressed", n)],
          "--n-text-color-focus": s ? x(s) : o[t("textColorTextHover", n)],
          "--n-text-color-disabled": s || o[t("textColorTextDisabled", n)]
        };
      } else if (F || D) {
        const s = p || l;
        i = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": l || o[t("rippleColor", n)],
          "--n-text-color": s || o[t("textColorGhost", n)],
          "--n-text-color-hover": s ? x(s) : o[t("textColorGhostHover", n)],
          "--n-text-color-pressed": s ? z(s) : o[t("textColorGhostPressed", n)],
          "--n-text-color-focus": s ? x(s) : o[t("textColorGhostHover", n)],
          "--n-text-color-disabled": s || o[t("textColorGhostDisabled", n)]
        };
      } else if (to) {
        const s = M ? o.textColor : P ? o.textColorTertiary : o[t("color", n)], c = l || s, T = y !== "default" && y !== "tertiary";
        i = {
          "--n-color": T ? w(c, {
            alpha: Number(o.colorOpacitySecondary)
          }) : o.colorSecondary,
          "--n-color-hover": T ? w(c, {
            alpha: Number(o.colorOpacitySecondaryHover)
          }) : o.colorSecondaryHover,
          "--n-color-pressed": T ? w(c, {
            alpha: Number(o.colorOpacitySecondaryPressed)
          }) : o.colorSecondaryPressed,
          "--n-color-focus": T ? w(c, {
            alpha: Number(o.colorOpacitySecondaryHover)
          }) : o.colorSecondaryHover,
          "--n-color-disabled": o.colorSecondary,
          "--n-ripple-color": "#0000",
          "--n-text-color": c,
          "--n-text-color-hover": c,
          "--n-text-color-pressed": c,
          "--n-text-color-focus": c,
          "--n-text-color-disabled": c
        };
      } else if (q || no) {
        const s = M ? o.textColor : P ? o.textColorTertiary : o[t("color", n)], c = l || s;
        q ? (i["--n-color"] = o.colorTertiary, i["--n-color-hover"] = o.colorTertiaryHover, i["--n-color-pressed"] = o.colorTertiaryPressed, i["--n-color-focus"] = o.colorSecondaryHover, i["--n-color-disabled"] = o.colorTertiary) : (i["--n-color"] = o.colorQuaternary, i["--n-color-hover"] = o.colorQuaternaryHover, i["--n-color-pressed"] = o.colorQuaternaryPressed, i["--n-color-focus"] = o.colorQuaternaryHover, i["--n-color-disabled"] = o.colorQuaternary), i["--n-ripple-color"] = "#0000", i["--n-text-color"] = c, i["--n-text-color-hover"] = c, i["--n-text-color-pressed"] = c, i["--n-text-color-focus"] = c, i["--n-text-color-disabled"] = c;
      } else
        i = {
          "--n-color": l || o[t("color", n)],
          "--n-color-hover": l ? x(l) : o[t("colorHover", n)],
          "--n-color-pressed": l ? z(l) : o[t("colorPressed", n)],
          "--n-color-focus": l ? x(l) : o[t("colorFocus", n)],
          "--n-color-disabled": l || o[t("colorDisabled", n)],
          "--n-ripple-color": l || o[t("rippleColor", n)],
          "--n-text-color": p || (l ? o.textColorPrimary : P ? o.textColorTertiary : o[t("textColor", n)]),
          "--n-text-color-hover": p || (l ? o.textColorHoverPrimary : o[t("textColorHover", n)]),
          "--n-text-color-pressed": p || (l ? o.textColorPressedPrimary : o[t("textColorPressed", n)]),
          "--n-text-color-focus": p || (l ? o.textColorFocusPrimary : o[t("textColorFocus", n)]),
          "--n-text-color-disabled": p || (l ? o.textColorDisabledPrimary : o[t("textColorDisabled", n)])
        };
      let N = {
        "--n-border": "initial",
        "--n-border-hover": "initial",
        "--n-border-pressed": "initial",
        "--n-border-focus": "initial",
        "--n-border-disabled": "initial"
      };
      h ? N = {
        "--n-border": "none",
        "--n-border-hover": "none",
        "--n-border-pressed": "none",
        "--n-border-focus": "none",
        "--n-border-disabled": "none"
      } : N = {
        "--n-border": o[t("border", n)],
        "--n-border-hover": o[t("borderHover", n)],
        "--n-border-pressed": o[t("borderPressed", n)],
        "--n-border-focus": o[t("borderFocus", n)],
        "--n-border-disabled": o[t("borderDisabled", n)]
      };
      const {
        [t("height", u)]: _,
        [t("fontSize", u)]: so,
        [t("padding", u)]: ao,
        [t("paddingRound", u)]: co,
        [t("iconSize", u)]: uo,
        [t("borderRadius", u)]: fo,
        [t("iconMargin", u)]: ho,
        waveOpacity: bo
      } = o, mo = {
        "--n-width": I && !h ? _ : "initial",
        "--n-height": h ? "initial" : _,
        "--n-font-size": so,
        "--n-padding": I || h ? "initial" : V ? co : ao,
        "--n-icon-size": uo,
        "--n-icon-margin": ho,
        "--n-border-radius": h ? "initial" : I || V ? _ : fo
      };
      return Object.assign(Object.assign(Object.assign(Object.assign({
        "--n-bezier": a,
        "--n-bezier-ease-out": d,
        "--n-ripple-duration": B,
        "--n-opacity-disabled": C,
        "--n-wave-opacity": bo
      }, io), i), N), mo);
    }), g = G ? Oo("button", $(() => {
      let r = "";
      const {
        dashed: a,
        type: d,
        ghost: o,
        text: B,
        color: C,
        round: E,
        circle: O,
        textColor: u,
        secondary: D,
        tertiary: y,
        quaternary: F,
        strong: h
      } = e;
      a && (r += "a"), o && (r += "b"), B && (r += "c"), E && (r += "d"), O && (r += "e"), D && (r += "f"), y && (r += "g"), F && (r += "h"), h && (r += "i"), C && (r += `j${W(C)}`), u && (r += `k${W(u)}`);
      const {
        value: l
      } = R;
      return r += `l${l[0]}`, r += `m${d[0]}`, r;
    }), K, e) : void 0;
    return {
      selfElRef: S,
      waveElRef: v,
      mergedClsPrefix: k,
      mergedFocusable: H,
      mergedSize: R,
      showBorder: m,
      enterPressed: b,
      rtlEnabled: ro,
      handleMousedown: X,
      handleKeydown: Y,
      handleBlur: Z,
      handleKeyup: U,
      handleClick: J,
      customColorCssVars: $(() => {
        const {
          color: r
        } = e;
        if (!r) return null;
        const a = x(r);
        return {
          "--n-border-color": r,
          "--n-border-color-hover": a,
          "--n-border-color-pressed": z(r),
          "--n-border-color-focus": a,
          "--n-border-color-disabled": r
        };
      }),
      cssVars: G ? void 0 : K,
      themeClass: g == null ? void 0 : g.themeClass,
      onRender: g == null ? void 0 : g.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: e,
      tag: S,
      onRender: v
    } = this;
    v == null || v();
    const b = Q(this.$slots.default, (m) => m && f("span", {
      class: `${e}-button__content`
    }, m));
    return f(S, {
      ref: "selfElRef",
      class: [
        this.themeClass,
        `${e}-button`,
        `${e}-button--${this.type}-type`,
        `${e}-button--${this.mergedSize}-type`,
        this.rtlEnabled && `${e}-button--rtl`,
        this.disabled && `${e}-button--disabled`,
        this.block && `${e}-button--block`,
        this.enterPressed && `${e}-button--pressed`,
        !this.text && this.dashed && `${e}-button--dashed`,
        this.color && `${e}-button--color`,
        this.secondary && `${e}-button--secondary`,
        this.loading && `${e}-button--loading`,
        this.ghost && `${e}-button--ghost`
        // required for button group border collapse
      ],
      tabindex: this.mergedFocusable ? 0 : -1,
      type: this.attrType,
      style: this.cssVars,
      disabled: this.disabled,
      onClick: this.handleClick,
      onBlur: this.handleBlur,
      onMousedown: this.handleMousedown,
      onKeyup: this.handleKeyup,
      onKeydown: this.handleKeydown
    }, this.iconPlacement === "right" && b, f(Po, {
      width: !0
    }, {
      default: () => Q(this.$slots.icon, (m) => (this.loading || this.renderIcon || m) && f("span", {
        class: `${e}-button__icon`,
        style: {
          margin: So(this.$slots.default) ? "0" : ""
        }
      }, f(To, null, {
        default: () => this.loading ? f($o, {
          clsPrefix: e,
          key: "loading",
          class: `${e}-icon-slot`,
          strokeWidth: 20
        }) : f("div", {
          key: "icon",
          class: `${e}-icon-slot`,
          role: "none"
        }, this.renderIcon ? this.renderIcon() : m)
      })))
    }), this.iconPlacement === "left" && b, this.text ? null : f(zo, {
      ref: "waveElRef",
      clsPrefix: e
    }), this.showBorder ? f("div", {
      "aria-hidden": !0,
      class: `${e}-button__border`,
      style: this.customColorCssVars
    }) : null, this.showBorder ? f("div", {
      "aria-hidden": !0,
      class: `${e}-button__state-border`,
      style: this.customColorCssVars
    }) : null);
  }
}), le = Io;
export {
  le as XButton,
  Fo as buttonProps,
  Io as default
};
